import { render, staticRenderFns } from "./orderinfo.vue?vue&type=template&id=2316e35a&scoped=true"
import script from "./orderinfo.vue?vue&type=script&lang=js"
export * from "./orderinfo.vue?vue&type=script&lang=js"
import style0 from "./orderinfo.vue?vue&type=style&index=0&id=2316e35a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2316e35a",
  null
  
)

export default component.exports